










import { Component, Vue } from 'vue-property-decorator'

// components
import Logo from '@/components/_uikit/Logo.vue'
import SidenavToggle from '@/components/layout/sidenavs/SidenavToggle.vue'

@Component({
  components: {
    Logo,
    SidenavToggle,
  },
})
export default class Auth extends Vue {}
